/* TULIMIŚ — „Wieczorny spokój”: pojawianie się elementów .tmn-reveal przy przewijaniu. */
(function () {
  if (window.__tmnReveal) return;
  window.__tmnReveal = true;
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('tmn-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan(root) { (root || document).querySelectorAll('.tmn-reveal:not(.is-in)').forEach(function (el) { io.observe(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* TULIMIŚ — pętla wideo z płynnym przenikaniem (bez „szarpnięcia” na końcu klipu).
   Markup: <div class="tmn-vid" data-tmn-loop><video muted playsinline preload="metadata" poster src></video></div>
   Druga warstwa wideo tworzona jest automatycznie. Odtwarza tylko, gdy kontener jest widoczny. */
(function () {
  if (window.__tmnLoop) return;
  window.__tmnLoop = true;
  var FADE = 0.9;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(box) {
    if (box.__tmnLoop) return;
    var a = box.querySelector('video');
    if (!a) return;
    box.__tmnLoop = true;
    a.muted = true; a.loop = false; a.playsInline = true;
    if (reduce) return; // tylko poster
    var b = a.cloneNode(true);
    b.classList.add('is-back'); b.removeAttribute('poster'); b.removeAttribute('autoplay'); b.autoplay = false; b.preload = 'none';
    a.removeAttribute('autoplay'); a.autoplay = false;
    box.appendChild(b);
    var front = a, back = b, visible = false, fading = false, raf = null;

    function tick() {
      raf = null;
      if (!visible) return;
      var d = front.duration;
      if (d && !fading && front.currentTime >= d - FADE) {
        fading = true;
        back.currentTime = 0;
        var p = back.play(); if (p && p.catch) p.catch(function () {});
        back.classList.remove('is-back'); front.classList.add('is-back');
        setTimeout(function () {
          front.pause();
          var t = front; front = back; back = t; fading = false;
        }, FADE * 1000);
      }
      raf = requestAnimationFrame(tick);
    }
    var warmed = false;
    function start() {
      if (!warmed) { warmed = true; back.preload = 'auto'; back.load(); }
      var p = front.play(); if (p && p.catch) p.catch(function () {});
      if (!raf) raf = requestAnimationFrame(tick);
    }
    function stop() { front.pause(); back.pause(); if (raf) { cancelAnimationFrame(raf); raf = null; } }
    box.__tmnPlay = function () { visible = true; start(); };
    box.__tmnStop = function () { visible = false; stop(); };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !box.hasAttribute('data-tmn-paused')) box.__tmnPlay(); else box.__tmnStop();
        });
      }, { threshold: 0.15 }).observe(box);
    } else { box.__tmnPlay(); }
  }
  function scan(root) { (root || document).querySelectorAll('[data-tmn-loop]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  window.tmnLoopScan = scan;
})();
